import debug from 'debug'

const LOG_PREFIX = 'soniq'

export function getInfoLogger(name: string) {
  return debug(`${LOG_PREFIX}:info:${name}`)
}

export function getErrorLogger(name: string) {
  return debug(`${LOG_PREFIX}:error:${name}`)
}

// Warnings share the error channel so they are on whenever
// errors are
export function getWarnLogger(name: string) {
  return debug(`${LOG_PREFIX}:error:${name}`)
}

export function getVerboseLogger(name: string) {
  return debug(`${LOG_PREFIX}:verbose:${name}`)
}

export function getAllLogger(name: string) {
  return {
    info: getInfoLogger(name),
    error: getErrorLogger(name),
    warn: getWarnLogger(name),
    verbose: getVerboseLogger(name),
  }
}

export function enableLogger(
  verbose?: boolean,
  prefixes: string[] = [LOG_PREFIX]
) {
  if (verbose) {
    debug.enable(
      prefixes
        .flatMap((prefix) => [
          `${prefix}:*`,
          `-${prefix}:trace:*`,
        ])
        .join(',')
    )
  } else {
    debug.enable(
      prefixes
        .flatMap((prefix) => [
          `${prefix}:*`,
          `-${prefix}:verbose:*`,
          `-${prefix}:trace:*`,
        ])
        .join(',')
    )
  }
}
